import React from "react";
import "./ReportsPage.scss";

import { useParams } from "react-router-dom";

const { REACT_APP_REPORT_BASE_URL = "https://gdev.gravoc.com" } = process.env;

const ReportsPage = () => {
  const { reportName } = useParams();
  const url = `${REACT_APP_REPORT_BASE_URL}/ReportViewer/ReportViewer.aspx?Path=${reportName}`;
  return (
    <div>
      <iframe src={url} title="Report Viewer" />
    </div>
  );
};

export default ReportsPage;
